export const HAS_ERROR = "has_error"
export const CLEAR_ERROR = "clear_error"